import React from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { TenantStatus } from '@debbie/common/dist/tenants/index.js';
import { selectMe } from '@debbie/cortex/dist/me/selectors.js';
const TenantSelector = (props) => {
    const me = useSelector(selectMe);
    const lang = useSelector((s) => s.lang);
    if (!me)
        return null;
    return (React.createElement(Select, { value: props.selected
            .map((id) => me.tenants.find((t) => t.id === id) || null)
            .filter((t) => t != null)
            .map((t) => ({
            label: `${t.name}${t.status !== TenantStatus.Active
                ? ` (${lang.tenantStatus[t.status]})`
                : ''}`,
            value: t.id,
        })), placeholder: lang.users.selectTenants, isMulti: true, name: "tenants", options: me.tenants.map((tenant) => {
            return {
                label: `${tenant.name}${tenant.status !== TenantStatus.Active
                    ? ` (${lang.tenantStatus[tenant.status]})`
                    : ''}`,
                value: tenant.id,
            };
        }), className: "creditors-select", classNamePrefix: "select", styles: {
            container: (base) => ({ ...base, marginBottom: '20px' }),
        }, onChange: (val) => {
            if (Array.isArray(val)) {
                props.onSelect(val.map((t) => t.value));
            }
        } }));
};
export default TenantSelector;
//# sourceMappingURL=TenantSelector.js.map